// extracted by mini-css-extract-plugin
module.exports = {"SearchPanel":"pf_a bhe_cw bhe_jx bhe_jo bhe_a bhe_j bhe_ri bhe_rj","SearchPanel__icon":"pf_b bhe_ui bhe_hb bhe_ro bhe_tu","SearchPanel__input":"pf_c bhe_iv bhe_cx bhe_z"};